import { NODE_TYPES } from '../../constants';
import { Node } from '../../types';

export const isNodeInlineEditEnabled = (node: Node) => node?.type === NODE_TYPES.NOTE;
